module.exports = __webpack_public_path__ + "static/media/logo1.b973c732.png";